module.exports = __webpack_public_path__ + "static/Logo-05983be795a1831886d658546c092043.png";